import { jsx as _jsx } from "react/jsx-runtime";
import FormModal from 'components/FormModal';
import TagsPanel from 'components/TagsPanel';
import { txt } from 'libs/i18n';
import { useComputed } from '@preact/signals-react/runtime';
import { useEditorContext } from '../../contexts/projectSignal';
const TagsModal = ({ visible, onClose, enqueueProjectUpdate }) => {
    const { projectSignal } = useEditorContext();
    const tags = useComputed(() => projectSignal.value.tags).value;
    return (_jsx(FormModal, { title: txt('tags'), open: visible, onCancel: onClose, destroyOnClose: true, footer: false, children: _jsx(TagsPanel
        //  NOTE: Tags in separate prop because we want to react and rerender only when they change.
        //  We do not want to track the whole project changes, we only peek at its initial  value
        // to get static data like project.id etc.
        , { 
            //  NOTE: Tags in separate prop because we want to react and rerender only when they change.
            //  We do not want to track the whole project changes, we only peek at its initial  value
            // to get static data like project.id etc.
            projectTags: tags, project: projectSignal.peek(), enqueueProjectUpdate: enqueueProjectUpdate }) }));
};
export default TagsModal;
